import { useContext, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import MainHeader from "../Components/MainHeader"
import './BoardEdit.css'


const BoardEdit = () => {
    const titleInput = useRef();
    const contentInput = useRef();
    const pwInput = useRef();

    const navigate = useNavigate();

    const parentFunction = (x) => {
    };

    const userData = JSON.parse(sessionStorage.getItem("UserData"));
    const userName = userData.name;

    const [state, setState] = useState({
        title: "",
        content: "",
        writer: userName,
        pw: "",
        board: "free"
    });

    const handleChangeState = (e) => {
        console.log(e.target.name);
        console.log(e.target.value);

        setState({
            ...state,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = () => {
        if (state.title.length < 1) {
            titleInput.current.focus();
            return;
        }
        if (state.content.length < 5) {
            contentInput.current.focus();
            return;
        }
        if (state.pw.length < 4) {
            pwInput.current.focus();
            return
        }
        console.log(state)
        alert("저장 성공!");
        setState({
            title: "",
            content: "",
            pw: "",
        });

        axios.post("https://yapyap.r-e.kr:8090/post", JSON.stringify(state), {
            headers: {
                "Content-Type": `application/json`,
            },
        }).then((res) => {
            console.log(res);
        })
        window.open('/Board', '_self');
    };


    return (
        <div >
            <div>
                <MainHeader parentFunction={parentFunction} />
            </div>
                <div className="BoardEdit">
                <div className="pageLeft">
                    <div className="titleInfo">제목:</div>
                    <div className="contentInfo">본문:</div>
                    <div className="passwordInfo">비밀번호:</div>
                </div>
                <div className="pageBody">

                        <div className="titleBox">

                        <input
                            ref={titleInput}
                            name="title"
                            value={state.title}
                            onChange={handleChangeState} />
                    </div>
                    <div className="contentBox">
                        <textarea
                            ref={contentInput}
                            name="content"
                            value={state.content}
                            onChange={handleChangeState} />
                    </div>
                    <div className="saveBox">
                        <div className="passwordBox">
                            <input ref={pwInput}
                                name="pw"
                                value={state.pw}
                                onChange={handleChangeState}
                            />
                        </div>
                        <button onClick={handleSubmit}>저장하기</button>
                    </div>
                </div>
                <div className="pageRight"></div>
            </div>
        </div >

    )
}

export default BoardEdit